import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { testnetAddresses } from '../../generated/testnetAddresses';
import { ChainId, type Token } from '../../types';
import { tao } from '../nativeTokens';

const wtao: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.wtao,
  decimals: 18,
  symbol: 'WTAO',
  iconSrc: iconSrcs.wtao,
  tokenWrapped: tao[ChainId.BITTENSOR_TESTNET],
};

const wsTAO: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.wsTAO,
  decimals: 18,
  symbol: 'wsTAO',
  displaySymbol: 'TAO',
  iconSrc: iconSrcs.taoSubnet0,
  tokenWrapped: tao[ChainId.BITTENSOR_TESTNET],
};

const alpha30: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.mockAlpha30,
  decimals: 18,
  symbol: 'ALPHA30',
  displaySymbol: 'alpha-30',
  iconSrc: iconSrcs.alpha,
};

const alpha64: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.mockAlpha64,
  decimals: 18,
  symbol: 'ALPHA64',
  displaySymbol: 'alpha-64',
  iconSrc: iconSrcs.alpha,
};

const wAlpha288: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.wAlpha288V2,
  decimals: 18,
  symbol: 'wAL-288',
  displaySymbol: 'Endure',
  iconSrc: iconSrcs.endure,
};

const wAlpha333: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.wAlpha333V2,
  decimals: 18,
  symbol: 'wAL-333',
  iconSrc: iconSrcs.alpha,
};

const wAlpha418: Token = {
  chainId: ChainId.BITTENSOR_TESTNET,
  address: testnetAddresses.wAlpha418V2,
  decimals: 18,
  symbol: 'wAL-418',
  displaySymbol: 'Score',
  iconSrc: iconSrcs.score,
};

export const bittensorTestnet: Token[] = [
  tao[ChainId.BITTENSOR_TESTNET],
  wtao,
  alpha30,
  alpha64,
  wAlpha288,
  wAlpha333,
  wAlpha418,
  wsTAO,
];
